module.exports = __webpack_public_path__ + "img/eval_activity.4601a2f4.svg";